/* ═════════════════════════════════════════════
   OBJEXYZ THEME — MAIN JS v3.2
   Development optimised August 26

   Cart architecture: one surface. The sticky cart bar is the live
   indicator, /cart is the full view. main.js owns cart STATE and
   broadcasts it; components listen for 'cart:updated'.

   The hero slider block was removed in v3.2 — it looked for #heroSlider,
   but sections/section-hero.liquid renders #heroCinema and ships its own
   slider, so none of that code had ever run.
   ═════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function () {

  /* ─── SHARED HELPERS ─── */
  const openLayers = new Set();
  function lockScroll(key)   { openLayers.add(key); document.body.style.overflow = 'hidden'; }
  function unlockScroll(key) { openLayers.delete(key); if (openLayers.size === 0) document.body.style.overflow = ''; }

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* PKR has no minor units in practice — match money_without_trailing_zeros */
  function formatMoney(cents) {
    return 'PKR ' + (cents / 100).toLocaleString('en-PK', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }

  const PLAY_SVG = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>';


  /* ─── MOBILE MENU ─── */
  const hamburger     = document.getElementById('hamburger');
  const mobileMenu    = document.getElementById('mobileMenu');
  const mobileOverlay = document.getElementById('mobileOverlay');
  const mobileClose   = document.getElementById('mobileClose');
  function openMobileMenu()  { mobileMenu?.classList.add('open');    mobileOverlay?.classList.add('open');    lockScroll('menu'); }
  function closeMobileMenu() { mobileMenu?.classList.remove('open'); mobileOverlay?.classList.remove('open'); unlockScroll('menu'); }
  hamburger?.addEventListener('click', openMobileMenu);
  mobileClose?.addEventListener('click', closeMobileMenu);
  mobileOverlay?.addEventListener('click', closeMobileMenu);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMobileMenu(); });


  /* ─── CART STATE ─── */
  const cartBadge = document.getElementById('cartBadge');

  function broadcastCart(cart) { document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart })); }
  function broadcastItemAdded(cart, item) { document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { cart, item } })); }

  function updateCartBadge(count) {
    if (!cartBadge) return;
    cartBadge.textContent = count;
    cartBadge.hidden = !(count > 0);
  }

  function syncCart(cart) {
    if (!cart) return;
    updateCartBadge(cart.item_count);
    broadcastCart(cart);
  }

  function addToCartAjax(variantId, quantity, onSuccess, onError) {
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: variantId, quantity }) })
      .then(r => { if (!r.ok) return r.json().then(err => Promise.reject(err)); return r.json(); })
      .then(addedItem => {
        fetch('/cart.js').then(r => r.json()).then(cart => {
          updateCartBadge(cart.item_count);
          broadcastItemAdded(cart, addedItem);
          broadcastCart(cart);
          if (onSuccess) onSuccess(addedItem);
        });
      })
      .catch(err => { if (onError) onError(err); });
  }

  /* Single owner of every .atc-form on the page, including the cart page
     upsell strip. Components that need to react listen for 'cart:updated'
     rather than binding their own submit handler. */
  function initAtcForms() {
    document.querySelectorAll('.atc-form').forEach(form => {
      if (form.dataset.init) return;
      form.dataset.init = '1';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        const btn = this.querySelector('.atc-btn'), orig = btn ? btn.textContent : '';
        if (btn) { btn.textContent = '...'; btn.disabled = true; }
        addToCartAjax(this.querySelector('[name="id"]').value, 1,
          () => { if (btn) { btn.textContent = '✓'; btn.disabled = false; setTimeout(() => { if (btn) btn.textContent = orig; }, 2000); } },
          () => { if (btn) { btn.textContent = 'Error'; btn.disabled = false; setTimeout(() => { if (btn) btn.textContent = orig; }, 2000); } }
        );
      });
    });
  }
  initAtcForms();
  document.addEventListener('cart:updated', initAtcForms);

  fetch('/cart.js').then(r => r.json()).then(syncCart).catch(() => {});


  /* ─── VIDEO PLAY BUTTONS ───
     Delegated so it covers the gallery, media swapped in by the thumbnails,
     and the standalone product video section. */
  document.addEventListener('click', function (e) {
    const playBtn = e.target.closest('.gallery-play');
    if (!playBtn) return;
    e.preventDefault();
    e.stopPropagation();
    const video = playBtn.parentElement ? playBtn.parentElement.querySelector('video') : null;
    if (!video) return;
    video.controls = true;
    const p = video.play();
    if (p && p.catch) p.catch(function () {});
    playBtn.hidden = true;
    video.addEventListener('ended', function () { playBtn.hidden = false; });
  });


  /* ─── PRODUCT GALLERY & LIGHTBOX ─── */
  const mainMediaWrap = document.getElementById('mainMediaWrap');
  const thumbs        = document.querySelectorAll('.thumb');
  const galleryImgsEl = document.getElementById('galleryImages');
  let galleryData = [];
  if (galleryImgsEl) galleryData = Array.from(galleryImgsEl.children).map(el => ({ type: el.dataset.type, full: el.dataset.full, poster: el.dataset.poster, alt: el.dataset.alt || '' }));

  function stopMainVideo() {
    const v = mainMediaWrap ? mainMediaWrap.querySelector('video') : null;
    if (v && !v.paused) v.pause();
  }

  function zoomBtnHtml(index) {
    return '<button class="gallery-zoom" id="galleryZoom" aria-label="Zoom" data-index="' + esc(index) + '">⤢</button>';
  }

  function renderImageMedia(thumb) {
    if (!mainMediaWrap) return;
    stopMainVideo();
    mainMediaWrap.innerHTML =
      '<img src="' + esc(thumb.dataset.posterLg) + '" alt="' + esc(thumb.dataset.alt || '') + '" id="mainImg" class="gallery-main-img" data-index="' + esc(thumb.dataset.index) + '">' +
      zoomBtnHtml(thumb.dataset.index);
  }

  function renderVideoMedia(thumb) {
    if (!mainMediaWrap) return;
    stopMainVideo();
    mainMediaWrap.innerHTML =
      '<video class="gallery-main-video" id="mainVideo" playsinline preload="none" poster="' + esc(thumb.dataset.posterLg) + '" src="' + esc(thumb.dataset.videoSrc) + '"></video>' +
      '<button type="button" class="gallery-play" aria-label="Play video">' + PLAY_SVG + '</button>' +
      zoomBtnHtml(thumb.dataset.index);
  }

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', function () {
      thumbs.forEach(t => t.classList.remove('active')); this.classList.add('active');
      if (this.dataset.mediaType === 'video') renderVideoMedia(this); else renderImageMedia(this);
    });
  });

  const lightbox        = document.getElementById('lightbox');
  const lightboxImg     = document.getElementById('lightboxImg');
  const lightboxVideo   = document.getElementById('lightboxVideo');
  const lightboxOverlay = document.getElementById('lightboxOverlay');
  const lightboxClose   = document.getElementById('lightboxClose');
  const lightboxPrev    = document.getElementById('lightboxPrev');
  const lightboxNext    = document.getElementById('lightboxNext');
  const lightboxCounter = document.getElementById('lightboxCounter');
  let lbIdx = 0;

  function stopLightboxVideo() { if (lightboxVideo && !lightboxVideo.paused) lightboxVideo.pause(); }

  function openLightbox(i)  { if (!lightbox || !galleryData.length) return; lbIdx = ((i%galleryData.length)+galleryData.length)%galleryData.length; showLbImg(lbIdx); lightbox.classList.add('open'); lockScroll('lightbox'); }
  function closeLightbox()  { stopLightboxVideo(); lightbox?.classList.remove('open'); unlockScroll('lightbox'); }
  function showLbImg(i) {
    stopLightboxVideo();
    lbIdx = ((i%galleryData.length)+galleryData.length)%galleryData.length;
    const item = galleryData[lbIdx];
    if (item && item.type === 'video') {
      if (lightboxImg) lightboxImg.style.display = 'none';
      if (lightboxVideo) {
        lightboxVideo.style.display = 'block';
        if (lightboxVideo.dataset.loaded !== item.full) { lightboxVideo.src = item.full; lightboxVideo.poster = item.poster; lightboxVideo.dataset.loaded = item.full; }
      }
    } else {
      if (lightboxVideo) lightboxVideo.style.display = 'none';
      if (lightboxImg) { lightboxImg.style.display = 'block'; lightboxImg.src = item ? item.full : ''; lightboxImg.alt = item ? item.alt : ''; }
    }
    if (lightboxCounter) lightboxCounter.textContent = `${lbIdx+1} / ${galleryData.length}`;
    const multi = galleryData.length > 1;
    if (lightboxPrev) lightboxPrev.style.display = multi ? 'flex' : 'none';
    if (lightboxNext) lightboxNext.style.display = multi ? 'flex' : 'none';
  }
  lightboxClose?.addEventListener('click', closeLightbox);
  lightboxOverlay?.addEventListener('click', closeLightbox);
  lightboxPrev?.addEventListener('click', () => showLbImg(lbIdx - 1));
  lightboxNext?.addEventListener('click', () => showLbImg(lbIdx + 1));

  const mainImgWrap = document.getElementById('mainImgWrap');
  mainImgWrap?.addEventListener('click', function(e) {
    /* The play button and the video's own controls must not open the lightbox */
    if (e.target.closest('.gallery-play')) return;
    if (e.target.closest('#mainVideo')) return;
    const zoomBtn = e.target.closest('#galleryZoom');
    if (zoomBtn) { e.stopPropagation(); openLightbox(parseInt(zoomBtn.dataset.index || 0)); return; }
    const mainImgEl = document.getElementById('mainImg');
    if (mainImgEl) openLightbox(parseInt(mainImgEl.dataset.index || 0));
  });
  document.addEventListener('keydown', e => { if(!lightbox?.classList.contains('open')) return; if(e.key==='Escape') closeLightbox(); if(e.key==='ArrowLeft') showLbImg(lbIdx-1); if(e.key==='ArrowRight') showLbImg(lbIdx+1); });


  /* ─── VARIANT SELECTOR ─── */
  const variantId = document.getElementById('variantId');
  const priceMain = document.getElementById('priceMain');
  const variants  = window.productVariants || [];

  const optionGroups = Array.from(document.querySelectorAll('.option-group'));

  function getSelectedOptions() {
    return optionGroups.map(group => {
      const checked = group.querySelector('input[type="radio"]:checked');
      return checked ? checked.value : null;
    });
  }

  function findVariant(selectedValues) {
    return variants.find(v => v.options.every((opt, i) => opt === selectedValues[i]));
  }

  function applyVariantState(matched) {
    if (!matched) return;
    if (variantId) variantId.value = matched.id;
    const isCustomSize = matched.options.some(o => o.indexOf('Custom Size') !== -1);
    const addBtn     = document.getElementById('addToCartBtn');
    const quoteBtn   = document.getElementById('requestQuoteBtn');
    const priceQuote = document.getElementById('priceQuote');
    const qtyGroup   = document.querySelector('.qty-group');
    if (isCustomSize) {
      if (addBtn)     { addBtn.style.display='none'; addBtn.disabled=true; }
      if (quoteBtn)   quoteBtn.style.display='flex';
      if (priceMain)  priceMain.style.display='none';
      if (priceQuote) priceQuote.hidden = false;
      if (qtyGroup)   qtyGroup.style.display='none';
    } else {
      if (addBtn)     { addBtn.style.display=''; addBtn.disabled=!matched.available; addBtn.textContent=matched.available?'ADD TO CART':'OUT OF STOCK'; }
      if (quoteBtn)   quoteBtn.style.display='none';
      if (priceMain)  { priceMain.style.display=''; priceMain.textContent = formatMoney(matched.price); }
      if (priceQuote) priceQuote.hidden = true;
      if (qtyGroup)   qtyGroup.style.display='';
    }
    document.dispatchEvent(new CustomEvent('product:variant-changed', {
      detail: { variant: matched, isQuoteOnly: isCustomSize }
    }));
  }

  /* The radio lives inside its <label>, so a tap anywhere on the button
     selects it natively. An extra click handler used to re-set .checked and
     dispatch a second change event for every tap — removed. */
  document.querySelectorAll('.option-values input[type="radio"]').forEach(radio => {
    radio.addEventListener('change', function () {
      const parent = this.closest('.option-group');
      parent?.querySelectorAll('.option-btn').forEach(b => b.classList.remove('active'));
      this.closest('.option-btn')?.classList.add('active');
      const idx = optionGroups.indexOf(parent) + 1;
      const lbl = document.getElementById('optionSelected' + idx);
      if (lbl) lbl.textContent = this.value;
      applyVariantState(findVariant(getSelectedOptions()));
    });
  });

  (function () {
    const checked = document.querySelector('.option-values input[type="radio"]:checked');
    if (checked) checked.dispatchEvent(new Event('change', { bubbles: true }));
  })();


  /* ─── PRODUCT FORM ─── */
  const productForm  = document.getElementById('productForm');
  const atcFeedback  = document.getElementById('atcFeedback');
  const addToCartBtn = document.getElementById('addToCartBtn');

  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addToCartBtn) { addToCartBtn.textContent='ADDING...'; addToCartBtn.disabled=true; }
      const id  = variantId ? variantId.value : this.querySelector('[name="id"]').value;
      const qty = parseInt(document.getElementById('qtyInput')?.value || 1);
      addToCartAjax(id, qty,
        () => {
          if (addToCartBtn) { addToCartBtn.textContent='✓ ADDED'; addToCartBtn.disabled=false; }
          if (atcFeedback)  { atcFeedback.textContent='Item added to your cart.'; atcFeedback.className='atc-feedback success'; atcFeedback.style.display='block'; }
          setTimeout(() => { if(addToCartBtn) addToCartBtn.textContent='ADD TO CART'; if(atcFeedback) atcFeedback.style.display='none'; }, 2500);
        },
        () => {
          if (addToCartBtn) { addToCartBtn.textContent='ADD TO CART'; addToCartBtn.disabled=false; }
          if (atcFeedback)  { atcFeedback.textContent='Something went wrong. Please try again.'; atcFeedback.className='atc-feedback error'; atcFeedback.style.display='block'; }
        }
      );
    });
  }


  /* ─── QUANTITY ─── */
  const qtyInput = document.getElementById('qtyInput');
  document.getElementById('qtyMinus')?.addEventListener('click', () => { if(qtyInput && parseInt(qtyInput.value)>1) qtyInput.value=parseInt(qtyInput.value)-1; });
  document.getElementById('qtyPlus')?.addEventListener('click',  () => { if(qtyInput) qtyInput.value=parseInt(qtyInput.value)+1; });


  /* ─── ACCORDION ─── */
  [['descToggle','descBody'],['shippingToggle','shippingBody']].forEach(([tId,bId]) => {
    const toggle=document.getElementById(tId), body=document.getElementById(bId), arrow=toggle?.querySelector('.desc-arrow');
    if(!toggle||!body) return;
    if(tId==='descToggle') { body.classList.add('open'); arrow?.classList.add('open'); }
    toggle.addEventListener('click', () => { body.classList.toggle('open'); arrow?.classList.toggle('open'); });
  });


  /* ─── QUOTE FORM ─── */
  const sendQuoteBtn  = document.getElementById('sendQuoteBtn');
  const quoteFeedback = document.getElementById('quoteFeedback');
  if (sendQuoteBtn) {
    sendQuoteBtn.addEventListener('click', function () {
      const name  = document.getElementById('quoteName')?.value?.trim();
      const email = document.getElementById('quoteEmail')?.value?.trim();
      if (!name || !email) { if(quoteFeedback){quoteFeedback.textContent='Please enter your name and email.';quoteFeedback.className='quote-feedback atc-feedback error';quoteFeedback.style.display='block';} return; }
      const size    = document.getElementById('quoteSize')?.value || '';
      const message = document.getElementById('quoteMessage')?.value || '';
      const title   = document.title.replace(' | OBJEXYZ','');
      window.location.href = `mailto:info@objexyz.com?subject=${encodeURIComponent('Quote Request: '+title)}&body=${encodeURIComponent(`Name: ${name}\nEmail: ${email}\nProduct: ${title}\nSize/Qty: ${size}\n\n${message}`)}`;
      if(quoteFeedback){quoteFeedback.textContent="Opening your email client — we'll respond within 24 hours.";quoteFeedback.className='quote-feedback atc-feedback success';quoteFeedback.style.display='block';}
    });
  }


  /* ─── SECTION CAROUSELS ─── */
  function initCarousel(cfg) {
    const track    = document.getElementById(cfg.trackId);
    const dotsWrap = document.getElementById(cfg.dotsId);
    const prevBtn  = document.querySelector(cfg.prevSel);
    const nextBtn  = document.querySelector(cfg.nextSel);
    if (!track) return;
    const cards = Array.from(track.children);
    const total = cards.length;
    if (total === 0) return;
    const AUTOPLAY_MS = 4000;
    let current = 0, timer = null, paused = false, userEngaged = false;

    function visibleCount() {
      if (window.innerWidth <= 480)  return Math.min(total, cfg.mobile  || 2);
      if (window.innerWidth <= 1024) return Math.min(total, cfg.tablet  || 2);
      return Math.min(total, cfg.desktop || 4);
    }
    function maxIndex() { return Math.max(0, total - visibleCount()); }

    function buildDots() {
      if (!dotsWrap) return;
      const pages = maxIndex() + 1;
      dotsWrap.innerHTML = Array.from({ length: pages }, (_, i) =>
        `<button class="${cfg.dotClass}${i===0?' active':''}" data-i="${i}" aria-label="Page ${i+1}"></button>`
      ).join('');
      dotsWrap.querySelectorAll('.'+cfg.dotClass).forEach(d => {
        d.addEventListener('click', function () { engage(); goTo(parseInt(this.dataset.i)); });
      });
    }
    function updateDots() {
      if (!dotsWrap) return;
      dotsWrap.querySelectorAll('.'+cfg.dotClass).forEach((d,i) => d.classList.toggle('active', i===current));
    }
    /* Hide the controls entirely when there is nothing to scroll to.
       They used to be merely disabled, so they stayed on screen and
       swallowed taps — a large share of the recorded dead clicks. */
    function updateControls() {
      const scrollable = maxIndex() > 0;
      if (prevBtn)  prevBtn.style.display  = scrollable ? 'flex' : 'none';
      if (nextBtn)  nextBtn.style.display  = scrollable ? 'flex' : 'none';
      if (dotsWrap) dotsWrap.style.display = scrollable ? 'flex' : 'none';
    }
    function goTo(n) {
      current = Math.max(0, Math.min(n, maxIndex()));
      const cardW = cards[0] ? cards[0].getBoundingClientRect().width : 0;
      track.style.transform = `translateX(-${current * (cardW + 2)}px)`;
      updateDots(); updateControls();
    }
    function next() { goTo(current >= maxIndex() ? 0 : current + 1); }
    function prev() { goTo(current <= 0 ? maxIndex() : current - 1); }
    function resetTimer() { clearInterval(timer); if (!paused && !userEngaged) timer = setInterval(next, AUTOPLAY_MS); }

    /* Once the visitor interacts, stop auto-advancing for good. A carousel
       sliding under a finger makes taps land on the wrong element, which
       the browser then discards as a non-click. */
    function engage() { userEngaged = true; paused = true; clearInterval(timer); }

    const wrap = track.closest(cfg.wrapSel);
    wrap?.addEventListener('mouseenter', () => { paused = true; clearInterval(timer); });
    wrap?.addEventListener('mouseleave', () => { if (!userEngaged) { paused = false; resetTimer(); } });
    prevBtn?.addEventListener('click', () => { engage(); prev(); });
    nextBtn?.addEventListener('click', () => { engage(); next(); });

    let touchStartX = 0;
    track.addEventListener('touchstart', e => { engage(); touchStartX = e.changedTouches[0].clientX; }, { passive: true });
    track.addEventListener('touchend',   e => { const dx = e.changedTouches[0].clientX - touchStartX; if (Math.abs(dx) > 50) { dx < 0 ? next() : prev(); } }, { passive: true });

    let resizeFrame = null;
    window.addEventListener('resize', () => {
      if (resizeFrame) cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(() => { buildDots(); goTo(Math.min(current, maxIndex())); });
    });

    document.addEventListener('visibilitychange', () => { if (document.hidden) clearInterval(timer); else resetTimer(); });

    buildDots(); goTo(0); resetTimer();
  }

  initCarousel({ trackId:'naTrack', dotsId:'naDots', prevSel:'.na-arrow-prev', nextSel:'.na-arrow-next', wrapSel:'.na-carousel-wrap', dotClass:'na-dot', desktop:4, tablet:2, mobile:2 });
  initCarousel({ trackId:'fpTrack', dotsId:'fpDots', prevSel:'.fp-arrow-prev', nextSel:'.fp-arrow-next', wrapSel:'.fp-carousel-wrap', dotClass:'fp-dot', desktop:3, tablet:2, mobile:1 });

});
